/* ============================================================
   DIMARK Promo Grid — Full-width expanding promo row
   - 4 boxes in a horizontal flex row (desktop)
   - Hover / focus expands box + fades in product panel
   - Touch: tap image to expand/collapse; only "View all" navigates
   - ATC: + expands into − | qty | + (same pattern as slideshow grid)
   ============================================================ */
(function () {
  'use strict';

  var HOVER_MQ = '(hover: hover) and (pointer: fine)';
  var REDUCE_MQ = '(prefers-reduced-motion: reduce)';

  function canHover() {
    return window.matchMedia(HOVER_MQ).matches;
  }

  function cartSectionsToRender() {
    var sections = 'cart-icon-bubble';
    var cartDrawer = document.querySelector('cart-drawer');
    var drawerSection = cartDrawer && cartDrawer.closest('.shopify-section');

    if (drawerSection) {
      sections += ',' + drawerSection.id.replace('shopify-section-', '');
    }

    document.querySelectorAll('quick-order-list').forEach(function (quickOrderList) {
      var closestSection = quickOrderList.closest('.shopify-section');
      if (closestSection) {
        sections += ',' + closestSection.id.replace('shopify-section-', '');
      }
    });

    return sections;
  }

  function shouldOpenDrawer() {
    if (!window.theme || !theme.settings) return false;

    return (
      theme.settings.afterAtc === 'drawer' ||
      (theme.settings.afterAtc === 'drawer_desktop' && theme.mediaMatches && theme.mediaMatches.md)
    );
  }

  function refreshCart(data, variantId) {
    var cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && data.sections && data.sections['cart-icon-bubble']) {
      cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
    }

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(data, shouldOpenDrawer());
    } else {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    }

    if (variantId != null) {
      document.dispatchEvent(new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: { variantId: data.variant_id || Number(variantId) }
      }));
    }
  }

  function setQtyState(atc, qty) {
    if (!atc) return;
    var valueEl = atc.querySelector('[data-dpr-qty-value]');
    var next = Math.max(Number(qty) || 0, 0);
    if (valueEl) valueEl.textContent = String(next);
    if (next > 0) atc.classList.add('is-qty');
    else atc.classList.remove('is-qty');
  }

  function syncAtcForVariant(root, variantId, qty) {
    if (variantId == null || !root) return;
    var id = String(variantId);
    root.querySelectorAll('.dpr-atc[data-variant-id]').forEach(function (atc) {
      if (String(atc.getAttribute('data-variant-id')) === id) {
        setQtyState(atc, qty);
      }
    });
  }

  function syncAllAtcFromCart(root) {
    var scope = root || document;
    var cartUrl = (window.theme && theme.routes && theme.routes.cart)
      ? theme.routes.cart
      : '/cart.js';

    return fetch(cartUrl, {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var qtyByVariant = {};
        (cart.items || []).forEach(function (item) {
          var id = String(item.variant_id);
          qtyByVariant[id] = (qtyByVariant[id] || 0) + (item.quantity || 0);
        });
        scope.querySelectorAll('.dpr-atc[data-variant-id]').forEach(function (atc) {
          var id = String(atc.getAttribute('data-variant-id'));
          setQtyState(atc, qtyByVariant[id] || 0);
        });
      })
      .catch(function (error) {
        console.error(error); // eslint-disable-line no-console
      });
  }

  function addToCart(variantId, atc, btn) {
    if (!variantId || !atc || atc.classList.contains('is-busy')) return;
    if (btn && btn.disabled) return;

    var cartAddUrl = (window.theme && theme.routes && theme.routes.cartAdd)
      ? theme.routes.cartAdd
      : '/cart/add.js';

    var prevQty = Number((atc.querySelector('[data-dpr-qty-value]') || {}).textContent) || 0;
    var optimisticQty = prevQty + 1;

    // Never use theme `.is-loading` — spinner steals ::before/::after plus icon
    atc.classList.add('is-busy');
    setQtyState(atc, optimisticQty);

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: cartSectionsToRender(),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) {
            throw new Error(data.description || data.message || 'Add to cart failed');
          }
          return data;
        });
      })
      .then(function (data) {
        refreshCart(data, variantId);
        setQtyState(atc, optimisticQty);
      })
      .catch(function (error) {
        console.error(error); // eslint-disable-line no-console
        setQtyState(atc, prevQty);
      })
      .then(function () {
        atc.classList.remove('is-busy');
      });
  }

  function changeQty(atc, delta) {
    if (!atc || atc.classList.contains('is-busy')) return;
    var variantId = atc.getAttribute('data-variant-id');
    var valueEl = atc.querySelector('[data-dpr-qty-value]');
    if (!variantId || !valueEl) return;

    var current = Number(valueEl.textContent) || 0;
    var next = Math.max(0, current + delta);
    var cartChangeUrl = (window.theme && theme.routes && theme.routes.cartChange)
      ? theme.routes.cartChange
      : '/cart/change.js';

    atc.classList.add('is-busy');
    setQtyState(atc, next);

    fetch(cartChangeUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: String(variantId),
        quantity: next,
        sections: cartSectionsToRender().split(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) {
            throw new Error(data.description || data.message || 'Cart update failed');
          }
          return data;
        });
      })
      .then(function (data) {
        refreshCart(data, null);
        setQtyState(atc, next);
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      })
      .catch(function (error) {
        console.error(error); // eslint-disable-line no-console
        setQtyState(atc, current);
      })
      .then(function () {
        atc.classList.remove('is-busy');
      });
  }

  function bindCartSync(stage) {
    if (stage.dataset.dprCartBound === '1') return;
    stage.dataset.dprCartBound = '1';

    document.addEventListener('on:line-item:change', function (event) {
      var detail = event.detail || {};
      if (detail.variantId == null) return;
      syncAtcForVariant(stage, detail.variantId, detail.newQuantity);
    });

    document.addEventListener('dispatch:cart-drawer:refresh', function () {
      syncAllAtcFromCart(stage);
    });

    document.addEventListener('on:cart:change', function () {
      syncAllAtcFromCart(stage);
    });
  }

  function initStage(stage) {
    var row = stage.querySelector('[data-dimark-promo-row]');
    if (!row) return;

    var boxes = Array.prototype.slice.call(row.querySelectorAll('[data-promo-box]'));
    if (!boxes.length) return;

    var activeBox = null;

    function setPanelState(box, open) {
      var panel = box.querySelector('[data-promo-panel]');
      if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    function collapseAll() {
      boxes.forEach(function (box) {
        box.classList.remove('is-expanded');
        setPanelState(box, false);
      });
      row.classList.remove('has-expanded');
      activeBox = null;
    }

    function expandBox(box) {
      if (activeBox === box && box.classList.contains('is-expanded')) return;
      boxes.forEach(function (b) {
        b.classList.remove('is-expanded');
        setPanelState(b, false);
      });
      box.classList.add('is-expanded');
      setPanelState(box, true);
      row.classList.add('has-expanded');
      activeBox = box;
    }

    if (canHover()) {
      boxes.forEach(function (box) {
        box.addEventListener('mouseenter', function () {
          expandBox(box);
        });
      });

      row.addEventListener('mouseleave', collapseAll);

      boxes.forEach(function (box) {
        box.addEventListener('focusin', function () {
          expandBox(box);
        });
      });

      row.addEventListener('focusout', function (e) {
        var next = e.relatedTarget;
        if (next && row.contains(next)) return;
        if (row.matches(':hover')) return;
        collapseAll();
      });
    } else {
      boxes.forEach(function (box) {
        var media = box.querySelector('[data-promo-media]');
        if (!media) return;

        media.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (activeBox === box && box.classList.contains('is-expanded')) {
            collapseAll();
          } else {
            expandBox(box);
          }
        });
      });

      document.addEventListener('click', function (e) {
        if (!stage.contains(e.target)) collapseAll();
      });
    }

    stage.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') collapseAll();
    });

    function navigateProductRow(e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      if (e.target.closest('.dpr-atc, .dpr-add, .dpr-price--login, .dpr-view-all, [data-dpr-qty-change], [data-dpr-add-to-cart]')) {
        return;
      }

      var productLink = e.target.closest('a.dpr-row__link');
      var productRow = e.target.closest('.dpr-row[data-product-url]');
      if (!productRow || !row.contains(productRow)) return;

      var url = productLink
        ? productLink.getAttribute('href')
        : productRow.getAttribute('data-product-url');

      if (!url || url === '#') return;

      e.preventDefault();
      window.location.assign(url);
    }

    row.addEventListener('click', navigateProductRow, true);

    row.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-dpr-qty-change]');
      if (qtyBtn && row.contains(qtyBtn)) {
        e.preventDefault();
        e.stopPropagation();
        var qtyAtc = qtyBtn.closest('.dpr-atc');
        if (!qtyAtc) return;
        changeQty(qtyAtc, Number(qtyBtn.getAttribute('data-dpr-qty-change')));
        return;
      }

      var plusBtn = e.target.closest('[data-dpr-add-to-cart]');
      if (plusBtn && row.contains(plusBtn) && !plusBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();

        var atc = plusBtn.closest('.dpr-atc');
        if (!atc) return;

        if (atc.classList.contains('is-qty')) {
          changeQty(atc, 1);
          return;
        }

        addToCart(plusBtn.getAttribute('data-variant-id'), atc, plusBtn);
      }
    });

    bindCartSync(stage);
    window.matchMedia(HOVER_MQ).addEventListener('change', collapseAll);
    window.matchMedia(REDUCE_MQ).addEventListener('change', collapseAll);
  }

  function init() {
    document.querySelectorAll('.dimark-promo-stage').forEach(initStage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var stage = evt.target.querySelector('.dimark-promo-stage');
    if (stage) initStage(stage);
  });
})();
